import { gql } from "@apollo/client";

const REASON_CODE_MAPPING_MUTATION_FIELDS = `
  mappingId
  purchaserId
  purchaserName
  purchaserKey
  reasonCode
  reasonCodeKey
  deductionTypeId
  deductionTypeName
  deductionTypeKey
  promoTypeId
  promoTypeName
  createdAt
  createdBy
  updatedAt
  updatedBy
`;

export const CREATE_MASTER_DATA_REASON_CODE_MAPPING = gql`
  mutation CreateMasterDataReasonCodeMapping(
    $params: CreateMasterDataReasonCodeMappingInput!
  ) {
    createMasterDataReasonCodeMapping(params: $params) {
      ${REASON_CODE_MAPPING_MUTATION_FIELDS}
    }
  }
`;

export const UPDATE_MASTER_DATA_REASON_CODE_MAPPING = gql`
  mutation UpdateMasterDataReasonCodeMapping(
    $params: UpdateMasterDataReasonCodeMappingInput!
  ) {
    updateMasterDataReasonCodeMapping(params: $params) {
      ${REASON_CODE_MAPPING_MUTATION_FIELDS}
    }
  }
`;

export const DELETE_MASTER_DATA_REASON_CODE_MAPPINGS = gql`
  mutation DeleteMasterDataReasonCodeMappings(
    $params: DeleteMasterDataReasonCodeMappingsInput!
  ) {
    deleteMasterDataReasonCodeMappings(params: $params) {
      deletedCount
      blockedCount
      blockedIds
      message
    }
  }
`;

export const DELETE_ALL_MASTER_DATA_REASON_CODE_MAPPINGS = gql`
  mutation DeleteAllMasterDataReasonCodeMappings {
    deleteAllMasterDataReasonCodeMappings {
      deletedCount
      blockedCount
      blockedIds
      message
    }
  }
`;
